export default {
    modals_upload_products_excel: {
        show: false,
        title: '',
        preloader: false
    },
    params: {
        document_id: null,
    },
    loading_upload_products_excel: {
        show: false
    }
}


// WEBPACK FOOTER //
// ./src/modules/modal-upload-products-excel/state.js